export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.901db5e7.worker.js");
}
